<template>
  <div class="home-container">
    <!-- 히어로: 시안의 견적 계산기 히어로 자리 (좌: 카피, 우: 견적 계산기 카드 2열 그리드) -->
    <div class="home-hero" id="order">
      <div class="home-hero-copy">
        <span class="home-hero-badge">설문 구걸은 이제 그만</span>
        <h1 class="home-hero-title">
          서베이지의<br>
          설문 응답 서비스를<br>
          이용해보세요
        </h1>
        <p class="home-hero-desc">
          빠르고 간편한 리서치 매칭 플랫폼, 서베이지가 편리한 리서치를 도와드려요.<br>
          보유한 패널을 통해 1~2일 안에 100개 이상의 설문 응답을 받을 수 있어요.
        </p>
        <ul class="home-hero-checklist">
          <li><span class="home-hero-check">✓</span>논스톱 업로드 — 3분 안에 주문할 수 있어요</li>
          <li><span class="home-hero-check">✓</span>빠른 응답 확보 — 18시간 안에 수집이 가능해요</li>
          <li><span class="home-hero-check">✓</span>어떤 폼이든 OK — 구글폼, 모아폼, Typeform</li>
        </ul>
      </div>
      <HomeOrderCalculatorVue />
    </div>

    <!-- PAIN: "설문 응답을 수집할 때마다 겪는 어려움들" 카드 3개 -->
    <HomePainVue />

    <!-- FOR YOU: "서베이지는 이런 분들이 사용하면 좋아요" 카드 3개 -->
    <HomeForYouVue />

    <!-- MERIT: 가격·주문 장점 리스트(타 서비스 대비 20% 저렴 등) -->
    <HomeMeritVue />

    <!-- WHY SURVEASY: "서베이지가 보유한 패널이 대신 응답해요" 카드 6개 -->
    <HomeWhySurveasyVue />

    <!-- PROCESS: 주문 흐름 설명 -->
    <HomeProcessVue />

    <!-- LIVE(진행중인 설문): Push 5에서 신규 홈 컴포넌트 삽입, GET /survey/list 그대로 사용, 필터 탭 없음 -->
    <HomeLiveSurveyVue />

    <!-- STATS(통계): Push 4에서 HomeStatics를 시안 4개 숫자 하드코딩으로 교체(GET /survey/count 호출 제거) -->
    <HomeStaticsVue />

    <!-- REVIEWS: Push 4에서 HomeReview를 캐러셀 → 카드 그리드 스타일로 교체(API는 그대로) -->
    <HomeReviewVue />

    <!-- FAQ: Push 6에서 신규 컴포넌트로 FAQ 5문항 하드코딩 삽입 -->
    <!-- REFUND: Push 6에서 신규 컴포넌트로 환불 정책 문구 하드코딩 삽입 -->
    <HomeFaqRefundVue />
  </div>
</template>

<script>
import HomeStaticsVue from '@/components/Home/HomeStatics.vue'
import HomeReviewVue from '@/components/Home/HomeReview.vue'
import HomeOrderCalculatorVue from '@/components/Home/HomeOrderCalculator.vue'
import HomeLiveSurveyVue from '@/components/Home/HomeLiveSurvey.vue'
import HomeFaqRefundVue from '@/components/Home/HomeFaqRefund.vue'
import HomePainVue from '@/components/Home/HomePain.vue'
import HomeForYouVue from '@/components/Home/HomeForYou.vue'
import HomeMeritVue from '@/components/Home/HomeMerit.vue'
import HomeWhySurveasyVue from '@/components/Home/HomeWhySurveasy.vue'
import HomeProcessVue from '@/components/Home/HomeProcess.vue'

export default {
  name: 'MainHome',
  components: {
    HomeStaticsVue,
    HomeReviewVue,
    HomeOrderCalculatorVue,
    HomeLiveSurveyVue,
    HomeFaqRefundVue,
    HomePainVue,
    HomeForYouVue,
    HomeMeritVue,
    HomeWhySurveasyVue,
    HomeProcessVue
  },
  mounted() {
    window.scrollTo(0,0)
  }
}
</script>

<style>
.home-container {
  display: flex;
  flex-direction: column;
}
.home-hero {
  display: flex;
  align-items: center;
  gap: 64px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 48px;
  box-sizing: border-box;
  background-color: var(--bg-page);
}

.home-hero-copy {
  flex: 1 1 0;
  min-width: 0;
  text-align: left;
  font-family: var(--font-sans);
}

.home-hero > .calc-card {
  flex: 1 1 0;
  min-width: 0;
}

.home-hero-badge {
  display: inline-block;
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  color: var(--green-700);
  background-color: var(--green-50);
  border: 1px solid var(--green-300);
  border-radius: 999px;
  padding: 6px 12px;
  margin-bottom: 20px;
}

.home-hero-title {
  font-size: 56px;
  font-weight: var(--font-weight-bold);
  line-height: 1.15;
  color: var(--ink-900);
  margin: 0 0 24px;
}

.home-hero-desc {
  font-size: 17px;
  line-height: 1.75;
  color: var(--ink-500);
  margin: 0 0 24px;
}

.home-hero-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.home-hero-checklist li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: var(--ink-700);
}

.home-hero-check {
  color: var(--green-500);
  font-weight: var(--font-weight-bold);
}

@media (max-width: 900px) {
  .home-hero {
    flex-direction: column;
    gap: 32px;
    padding: 32px 16px 48px;
  }

  .home-hero-title {
    font-size: 34px;
  }

  .home-hero-desc {
    font-size: 15px;
  }
}
</style>
